import React, { Component } from 'react';

import './articleContact.scss';

class ArticleContact extends Component {
  constructor(props, context){
    super(props)
    this.state = {}
  }
  render() {
    // this.props.languageStatus= 0(双语), 1(原文), 2(译文), 3(隐藏)
    const articleContact = this.props.articleContact
    const length = Math.ceil(articleContact.length/3)
    const title = this.props.title
    return (
      <div className="article_contact">
        {
          !this.props.vip && this.props.languageStatus !== 3 && <div className="contact">
            <h4>{title}</h4>
            <div className="cut_off_rule"></div>
            <ul>
              {
                articleContact && articleContact.map((item, index) =>{
                  if (index < length) {
                    return (<li key={index.toString()}>
                      {
                        item.type === 'INTRO' ? <p className={index === this.props.audioParagraphIndex ? 'intro is_playing' : 'intro'} onClick={()=>this.props.contralAudioTime(item.startTs, index)}>{item.data.text}</p> : ''
                      }
                      {
                        item.type === 'TEXT' ? <div className="article_sentence" onClick={()=>this.props.contralAudioTime(item.startTs, index)}>
                          {this.props.languageStatus !== 2 && this.props.languageStatus !== 3  && <p className={index === this.props.audioParagraphIndex ? 'sentence is_playing' : 'sentence'}>{item.data.text}</p>}
                          {this.props.languageStatus !== 1 && this.props.languageStatus !== 3  && <p className="sentence_trans">{item.data.trans}</p>}
                        </div> : ''
                      }
                      {
                        item.type === 'IMAGE' ? <img src={item.data.url} className="article_image"/> : ''
                      }
                    </li>)
                  }
                })
              }
            </ul>
          </div>
        }
        {
          !this.props.vip && this.props.languageStatus === 3 && <div className="hidden_mode" onClick={()=>this.props.changelanguageStatus()}>
            <img src="http://ydschool-online.nos.netease.com/1572944240776img_audio_article_cover%402x.png" className="article_image"/>
            <img src="http://ydschool-online.nos.netease.com/1572944256493img_audio_article_cover_shadow%402x.png" className="article_image"/>
            <p className="title">{title}</p>
            <p className="desc">文字内容已隐藏，可点击屏幕查看。</p>
          </div>
        }
        {
          this.props.vip &&  <div className="hidden_mode" onClick={()=>this.props.changelanguageStatus()}>
            <img src="http://ydschool-online.nos.netease.com/1572944240776img_audio_article_cover%402x.png" className="article_image"/>
            <img src="http://ydschool-online.nos.netease.com/1572944256493img_audio_article_cover_shadow%402x.png" className="article_image"/>
            <p className="title">{title}</p>
            <p className="desc">此内容为会员专享，开通VIP立即畅听</p>
          </div>
        }
      </div>
    );
  }
}

export default ArticleContact;
